import { render, staticRenderFns } from "./carnet-covid19.vue?vue&type=template&id=44591a04"
import script from "./carnet-covid19.vue?vue&type=script&lang=ts"
export * from "./carnet-covid19.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44591a04')) {
      api.createRecord('44591a04', component.options)
    } else {
      api.reload('44591a04', component.options)
    }
    module.hot.accept("./carnet-covid19.vue?vue&type=template&id=44591a04", function () {
      api.rerender('44591a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/carnet-covid19.vue"
export default component.exports